<script>
import layout from '@src/mixins/layout.vue'
import NavigateMixin from '@src/mixins/navigate-mixin.vue'

export default {
  components: {},
  page: {
    title: 'Confirm appointment',
    meta: [{ name: 'description', content: 'The Confirm Appointment page.' }],
  },
  mixins: [layout, NavigateMixin],
  data() {
    return {
      providerDetails: {},
      providerName: '',
      appointmentDate: '',
      appointmentTime: '',
      appointmentNotes: '',
      cancelApp: false,
    }
  },

  methods: {
    navigateTo(route) {
      this.navigateToScreen(route)
    },
  },
}
</script>

<template>
  <v-container class="$style.mainContainer">
    <v-row>
      <v-col
        cols="24"
        sm="12"
        md="12"
        lg="5"
        xl="4"
        :align="notDesktop ? 'center' : 'start'"
        fill-height
      >
        <div :class="$style.textContainer">
          <p :class="$style.appointmentText">Cancellation Confirmed</p>
        </div>

        <div class="d-flex flex-row mt-2" :class="$style.cardCustom">
          <div>
            <a
              :class="$style.ancolButton"
              @click="navigateTo('safehaven-calendar')"
            >
              View Calendar
            </a>
            <span :class="$style.spanSeperator">&nbsp;| &nbsp;</span>
            <a
              :class="$style.ancolButton"
              @click="navigateTo('safehaven-dashboard')"
            >
              Visit Dashboard
            </a>
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" module>
@import '@design';

p {
  margin-bottom: 0 !important;
}

.mainContainer {
  padding-right: 20px !important;
  padding-left: 20px !important;
}

.textContainer {
  margin-top: 50px;
  text-align: left;
}

.appointmentText {
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: #000;
  text-align: left;
  letter-spacing: 0.5px;
}

.cardCustom {
  padding: 10px 0 10px 0;
}

.ancolButton {
  padding-right: 10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  letter-spacing: 0.10000000149011612px;
}

.spanSeperator {
  color: #ccc;
}
</style>
